const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "File Name",
    dataIndex: "file_name",
    render: (value) => <p className="capitalize">{value}</p>,
  },
  {
    title: "File No.",
    dataIndex: "file_number",
    render: defaultRender,
  },
  {
    title: "Frequency Type",
    dataIndex: "frequency_type",
    render: defaultRender,
  },
  {
    title: "Submit Order",
    dataIndex: "frequency_order",
    render: defaultRender,
  },
  {
    title: "Submitted Date",
    dataIndex: "submittedDate",
    render: defaultRender,
  },
  {
    title: "Completion Document",
    dataIndex: "completionDocument",
    render: defaultRender,
  },
  {
    title: "Completion Notes",
    dataIndex: "completionNotes",
    render: defaultRender,
  },
  {
    title: "Completed Date",
    dataIndex: "completedDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    fixed: "right",
  },
];

export default columns;
